import React, { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';
import { NavLinkConfig } from '../../data/types/nav';
import env from '../../env';

const GlobalErrorHandlerProviders = lazy(
  () => import('../GlobalErrorHandlerProviders')
);
const LegacyAppRedirect = lazy(() => import('./LegacyAppRedirect'));

export default {
  element: (
    <Suspense>
      <GlobalErrorHandlerProviders>
        <Suspense>
          <Outlet />
        </Suspense>
      </GlobalErrorHandlerProviders>
    </Suspense>
  ),
  children: Object.values<NavLinkConfig>(NavConfig.linkConfigs)
    .filter(
      ({ id: linkId, toLegacy }) =>
        !env.reactMigration.migratedLinks[linkId] && toLegacy
    )
    .map((link) => ({
      id: `LEGACY_REDIRECT_${link.id}`,
      path: link.to,
      element: <LegacyAppRedirect toLegacy={link.toLegacy} />,
    })),
};
